export const INVOICE_SUMMARY_TEST_IDS = {
  creationDate: 'creation-date',
  number: 'invoice-number',
  description: 'invoice-description'
};
